import React, { useState } from "react";
import Sidebar from "../commanComponents/Sidebar";
import Header from "../commanComponents/Header";
import "./components.css";

export default function ComponentWrapper({ children, active }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className={`mainLayoutWrapper ${isSidebarOpen ? "sidebar-open" : ""}`}>
      {isSidebarOpen && (
        <div 
          className="sidebar-overlay" 
          onClick={() => setIsSidebarOpen(false)}
        />
      )}
      <Sidebar active={active} isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      <div className="mainLayoutRight">
        <Header onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />
        <div className="mainContentArea">
          {children}
        </div>
      </div>
    </div>
  );
}
